import { FleekError } from './FleekError';

// eslint-disable-next-line @typescript-eslint/ban-types
type FleekFunctionsNotFoundErrorOptions = {};

export class FleekFunctionsNotFoundError extends FleekError<FleekFunctionsNotFoundErrorOptions> {
  public name = 'FleekFunctionsNotFoundError';

  toString = () => 'No functions found.';
}
